import Vue from 'vue'
import Component from 'vue-class-component'
import Pagination from "@/components/paginaiton.vue";
import Empty from "@/components/empty.vue";
@Component({
  components: {
    Pagination,
    Empty,
  },
})
export class listMixin extends Vue {
  ifShowEmpty: any = false;
  filters: any = {
    search: "",//搜索
    sort_field: "创建时间",
    sort_value: "-1",// 排序
    total_page: 0, // 总页码
    total_count: 0, // 总条数
    page_count: 10, //每页条数
    current_page: 1, // 当前页码
    startTime: null,
    endTime: null
  };
  selectedMessages: any = []
  selectAll(d: any, key: any) {
    d.forEach((ele: any) => {
      if (!ele.selected) {
        ele.selected = true;
        this.selectedMessages.push(ele)
      }
    });
  }
  // 选中改变
  selectChange(value: any, item: any, uniKey: any) {
    if (item.selected) {
      this.selectedMessages.push(item);
    } else {
      const index = this.selectedMessages.findIndex((val: any) => {
        return val[uniKey] = item[uniKey]
      });
      this.selectedMessages.splice(index, 1);
    }
  }
  preview(url: any) {
    window.open(url)
  }
  getList() { }
  /**
    * @description 搜索
    */
  search() {
    this.$forceUpdate();
    this.filters.current_page = 1;
    this.getList();
  }
  /**
   * @description 处理排序变化
   */
  private handleSortChange(ev: any) {
    this.filters.sort_field = ev["prop"];
    this.filters.sort_value = ev["order"] === "ascending" ? "0" : "-1";
    this.search();
  }
  /**
   * @description 处理翻页器的当前页变化
   */
  private handleCurrentPageChange(val: any) {
    this.filters.current_page = val;
    this.getList();
  }
  /**
   * @description 处理翻页器的每页条数变化
   */
  private handleCurrentSizeChange(val: any) {
    this.filters.current_page = 1;
    this.filters.page_count = val;
    this.getList();
  }
  mounted() {
    // const h = document.body.clientHeight;
    // if (h > 800) {
    //   this.filters.page_count = 20
    // } else {
    //   this.filters.page_count = 10
    // }
  }
}